import { Icon } from "@iconify/react";

import carOutline from "@iconify/icons-eva/car-outline";
import gridOutline from "@iconify/icons-eva/grid-outline";
import homeOutline from "@iconify/icons-eva/home-outline";
import searchOutline from "@iconify/icons-eva/search-outline";
import peopleOutline from "@iconify/icons-eva/people-outline";
import personOutline from "@iconify/icons-eva/person-outline";
import fileTextOutline from "@iconify/icons-eva/file-text-outline";
import pricetagOutline from "@iconify/icons-eva/pricetags-outline";
import personAddOutline from "@iconify/icons-eva/person-add-outline";
import creditCardOutline from "@iconify/icons-eva/credit-card-outline";
import keyPadFill from "@iconify/icons-eva/keypad-fill";
import layersOutline from "@iconify/icons-eva/layers-outline";
import options2OutLine from "@iconify/icons-eva/options-2-outline";
import barChartOutline from "@iconify/icons-eva/bar-chart-outline";
import trendingUpOutline from "@iconify/icons-eva/trending-up-outline";
import giftOutline from "@iconify/icons-eva/gift-outline";
import clipboardOutline from "@iconify/icons-eva/clipboard-outline";

const getIcon = (name: any) => <Icon icon={name} width={20} height={20} />;

function changeSideBar(token: string | null): any {
  var sidebarConfig: Array<any> = [
    {
      title: "início",
      path: "/dashboard/app",
      icon: getIcon(homeOutline),
    },
  ];
  if (token) {
    const user = JSON.parse(token);
    if (user.role === "Cliente") {
      sidebarConfig[0].title = "VIDEOS";
      sidebarConfig.push(
        {
          title: "CADASTRAR O.S",
          path: "/dashboard/cadastrar",
          icon: getIcon(keyPadFill),
        },
        {
          title: "MINHAS OS's",
          path: "/dashboard/pedidos",
          icon: getIcon(carOutline),
        },
        {
          title: "RELATÓRIOS",
          path: "/dashboard/relatorio",
          icon: getIcon(fileTextOutline),
        },
        {
          title: "MEUS DADOS",
          path: "/dashboard/dados",
          icon: getIcon(personOutline),
        }
      );

      if (user.courtesy)
        sidebarConfig.push({
          title: "CORTESIAS",
          path: "/dashboard/minhas-cortesias",
          icon: getIcon(pricetagOutline),
        });
    } else if (user.role === "Operacional") {
      sidebarConfig.push(
        {
          title: "pedidos",
          path: "/dashboard/operacional",
          icon: getIcon(carOutline),
        },
        {
          title: "buscar",
          path: "/dashboard/buscar",
          icon: getIcon(searchOutline),
        },
        {
          title: "Relatório Operacional",
          path: "/dashboard/relatorio-operacional",
          icon: getIcon(clipboardOutline),
        },
        {
          title: "Filtros avançados",
          path: "/dashboard/filtros-avancados",
          icon: getIcon(options2OutLine),
        }
      );
    } else if (user.role === "Vendedor") {
      sidebarConfig.push({
        title: "clientes",
        path: "/dashboard/clientes",
        icon: getIcon(personAddOutline),
      });
    } else if (user.role === "Financeiro") {
      sidebarConfig.push({
        title: "financeiro",
        path: "/dashboard/financeiro",
        icon: getIcon(creditCardOutline),
      });
    } else if (user.role === "Diretor") {
      sidebarConfig.push(
        {
          title: "financeiro",
          path: "/dashboard/financeiro",
          icon: getIcon(creditCardOutline),
        },
        {
          title: "reports",
          path: "/dashboard/reports",
          icon: getIcon(barChartOutline),
        },
        {
          title: "Ranking AR",
          path: "/dashboard/ranking-ar",
          icon: getIcon(trendingUpOutline),
        },
        {
          title: "Visão por cliente",
          path: "/dashboard/visao-cliente",
          icon: getIcon(peopleOutline),
        },
        {
          title: "Comparativo",
          path: "/dashboard/comparativo-clientes",
          icon: getIcon(peopleOutline),
        }
      );
    } else if (user.role === "Comercial") {
      sidebarConfig.push(
        { title: "Visão por cliente", path: "/dashboard/visao-cliente", icon: getIcon(peopleOutline) },
        { title: "Relatório Operacional", path: "/dashboard/relatorio-operacional", icon: getIcon(clipboardOutline) },
        { title: "Filtros avançados", path: "/dashboard/filtros-avancados", icon: getIcon(options2OutLine) },
        {
          title: "clientes",
          path: "/dashboard/clientes",
          icon: getIcon(personAddOutline),
        },
        {
          title: "etiquetas",
          path: "/dashboard/etiquetas",
          icon: getIcon(pricetagOutline),
        },
        {
          title: "cortesias",
          path: "/dashboard/cortesias",
          icon: getIcon(giftOutline),
        },
        {
          title: "produtos",
          path: "/dashboard/produtos",
          icon: getIcon(gridOutline),
        },
        {
          title: "administração",
          path: "/dashboard/administracao",
          icon: getIcon(options2OutLine),
        },
        {
          title: "reports",
          path: "/dashboard/reports",
          icon: getIcon(barChartOutline),
        },
        {
          title: "Grupos",
          path: "/dashboard/grupos",
          icon: getIcon(layersOutline),
        },
        {
          title: "OS's",
          path: "/dashboard/relatorio-admin",
          icon: getIcon(fileTextOutline),
        }
      );
    } else {
      sidebarConfig = [
        {
          title: "Início",
          path: "/dashboard/app",
          icon: getIcon(homeOutline),
        },
        {
          title: "Cadastros",
          icon: getIcon(personAddOutline),
          children: [
            {
              title: "Clientes",
              path: "/dashboard/clientes",
              icon: getIcon(personAddOutline),
            },
            {
              title: "Colaboradores",
              path: "/dashboard/colaboradores",
              icon: getIcon(peopleOutline),
            },
            {
              title: "Grupos",
              path: "/dashboard/grupos",
              icon: getIcon(layersOutline),
            },
            {
              title: "Produtos",
              path: "/dashboard/produtos",
              icon: getIcon(gridOutline),
            },
            {
              title: "Etiquetas",
              path: "/dashboard/etiquetas",
              icon: getIcon(pricetagOutline),
            },
            {
              title: "Cortesias",
              path: "/dashboard/cortesias",
              icon: getIcon(giftOutline),
            },
            {
              title: "Administração",
              path: "/dashboard/administracao",
              icon: getIcon(options2OutLine),
            },
          ],
        },
        {
          title: "Financeiro",
          icon: getIcon(creditCardOutline),
          children: [
            {
              title: "Fechamentos",
              path: "/dashboard/financeiro",
              icon: getIcon(creditCardOutline),
            },
            {
              title: "Reports",
              path: "/dashboard/reports",
              icon: getIcon(barChartOutline),
            },
            {
              title: "Ranking AR",
              path: "/dashboard/ranking-ar",
              icon: getIcon(trendingUpOutline),
            },
            ...(user.role === "Administrador" ? [{
              title: "Visão por cliente",
              path: "/dashboard/visao-cliente",
              icon: getIcon(peopleOutline),
            }] : []),
            {
              title: "Comparativo",
              path: "/dashboard/comparativo-clientes",
              icon: getIcon(peopleOutline),
            },
          ],
        },
        {
          title: "Operação",
          icon: getIcon(carOutline),
          children: [
            {
              title: "Pedidos",
              path: "/dashboard/operacional",
              icon: getIcon(carOutline),
            },
            {
              title: "Buscar",
              path: "/dashboard/buscar",
              icon: getIcon(searchOutline),
            },
            {
              title: "OS's",
              path: "/dashboard/relatorio-admin",
              icon: getIcon(fileTextOutline),
            },
            {
              title: "Relatório operacional",
              path: "/dashboard/relatorio-operacional",
              icon: getIcon(clipboardOutline),
            },
            {
              title: "Filtros avançados",
              path: "/dashboard/filtros-avancados",
              icon: getIcon(options2OutLine),
            },
          ],
        },
      ];
    }
  }

  return sidebarConfig;
}

export default changeSideBar;
